export default __webpack_public_path__ + "static/media/service-mobile-applications.8cbf4bdd.png";